import ICON from "components/icons/arrowLeftAdornment.svg";

import "./MobileBackButton.scss";

export const MobileBackButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button className="mobileBackButton" onClick={props.onClick}>
      <img src={ICON} alt="" />
    </button>
  );
};
